TutorialCtrl.$inject = ['$rootScope', '$scope', '$window'];

export default function TutorialCtrl($rootScope, $scope, $window) {
    $scope.openAddFact = function () {
        // Sets the name of the current window for Add Fact windows to reference
        $window.name = 'Factbox BOC';
        // prevent the fact window from navigating to case
        $rootScope.preventCaseChange = true;
        var url = '#/fact/';
        $window.open(url,
            '_blank', 'height=525,width=475,status=no,scrollbars=no, resizable=yes');
    };
}



// WEBPACK FOOTER //
// ./project/pages/tutorial/tutorial.controller.js